"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = void 0;
const react_1 = __importDefault(require("react"));
const FormField_1 = require("./FormField");
class FormGroup extends FormField_1.FormField {
    render() {
        return (react_1.default.createElement("div", { className: "form-group" }, this.props.config.value().map((e, i) => (react_1.default.createElement("div", { className: "form-group__element", key: i }, this.props.element((fieldName) => this.getConfig(i, fieldName), i))))));
    }
    getConfig(index, fieldName) {
        return {
            value: () => this.props.config.value()[index][fieldName],
            setValue: (valueUpdateFunction) => __awaiter(this, void 0, void 0, function* () { return this.setFieldValue(index, fieldName, valueUpdateFunction); }),
            errors: this.props.config.errors.filter(e => e.index === index && e.arrayFieldName === fieldName)
        };
    }
    setFieldValue(index, fieldName, valueUpdateFunction) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.props.config.setValue(v => {
                let elem = v[index];
                elem = Object.assign(Object.assign({}, elem), { [fieldName]: valueUpdateFunction(elem[fieldName]) });
                v[index] = elem;
                return v;
            });
        });
    }
}
exports.FormGroup = FormGroup;
//# sourceMappingURL=FormGroup.js.map